const validateSession = async () => {
    const apiUrl = window.location.protocol + '//' + window.location.host + '/api/BackChannelLogout/validate-session';

    return await  fetch(apiUrl, {
        method: 'get',
        headers: new Headers({
            'Authorization': 'Bearer ' + window.getTheToken()
        })
    })
    .then(res => res.json())
    .then((data:boolean) => {
            return data;
    });
}

export default validateSession